<template>
    <SwitchGroup as="div" class="flex items-center justify-between gap-x-2">
        <Switch
            :model-value="props.modelValue"
            class="
        relative 
        inline-flex 
        h-6 
        vxl:h-8 
        w-11 
        vxl:w-14 
        shrink-0 
        cursor-pointer 
        rounded-full 
        border-2 
        border-transparent 
        transition-colors
        duration-400
        ease-in-out
        focus:outline-none 
        focus:ring-2 
        focus:ring-offset-2
      " 
            :class="`${props.modelValue ? '' : 'bg-black/25'}`" 
            :style="`${props.modelValue ? 'background-color: '+props.toggleActiveColour : ''}`"
            @click="updateModelValue(!props.modelValue, props.disabled)"
        >
            <span
                aria-hidden="true"
                class="
          toggleButton
          pointer-events-none 
          inline-block 
          h-5 
          vxl:h-7
          w-5 
          vxl:w-7
          transform 
          rounded-full 
          shadow 
          ring-0 
          transition 
          duration-200 
          ease-in-out
        "
                :class="[
                    { 'translate-x-5 vxl:translate-x-6': modelValue },
                    { 'translate-x-0': !modelValue }
                ]"
                :style="'--toggle-bg: ' + (props.modelValue && props.toggleCircleColour ? props.toggleCircleColour : props.textColour) + ';'"
            />
        </Switch>
        <span class="flex grow flex-col">
            <SwitchLabel
                v-if="toggleLabel"
                as="span"
                class="font-light leading-6 text-fl-base"
                :class="props.textColour"
                passive
            >{{ toggleLabel }}</SwitchLabel>
            <SwitchDescription
                v-if="toggleDescription"
                as="span"
                class="text-fl-base text-gray-500"
            >{{ toggleDescription }}</SwitchDescription>
        </span>
    </SwitchGroup>
</template>

<script setup>
import { ref, watch } from 'vue'
import { Switch, SwitchDescription, SwitchGroup, SwitchLabel } from '@headlessui/vue'

const props = defineProps({
    toggleLabel: {
        type: String,
        default: undefined,
    },
    toggleDescription: {
        type: String,
        default: undefined,
    },
    disabled: Boolean,
    modelValue: Boolean,
    textColour: {
        type: String,
        default: 'text-gray-900',
    },
    toggleActiveColour: {
        type: String,
        default: 'bg-(--brand-colour)',
    },
    toggleCircleColour: {
        type: String,
        default: null,
    },
})

const emit = defineEmits(['update:modelValue'])

function updateModelValue(value, disabled) {
    if (!disabled) emit('update:modelValue', value)
}

</script>

<style scoped>
.toggleButton {
  transition: transform 0.4s ease, background-color 0.4s ease;
  background-color: var(--toggle-bg);
}
</style>